import { render, staticRenderFns } from "./Chassis.vue?vue&type=template&id=0c64639f&"
import script from "./Chassis.vue?vue&type=script&lang=ts&"
export * from "./Chassis.vue?vue&type=script&lang=ts&"
import style0 from "./Chassis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports